// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';  // 假设你有 Firebase 配置文件
import Home from './Home';  // 引入 Home 组件
import Login from './Login';  // 引入 Login 组件

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // 监听认证状态
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsAuthenticated(true);  // 用户登录
      } else {
        setIsAuthenticated(false);  // 用户未登录
      }
    });

    return () => unsubscribe();  // 清理订阅
  }, []);

  return (
    <Router>
      <Routes>
        {isAuthenticated ? (
          // 如果已登录，展示 Home 页面
          <Route path="/" element={<Home />} />
        ) : (
          // 如果未登录，展示 Login 页面
          <Route path="/" element={<Login onLogin={() => setIsAuthenticated(true)} />} />
        )}
      </Routes>
    </Router>
  );
}

export default App;